import { supabase } from './supabase';

/**
 * School vacations / days off.
 *
 * Table: public.school_vacations
 * - id uuid
 * - school_id uuid
 * - title text (optional)
 * - start_date date (YYYY-MM-DD)
 * - end_date date (YYYY-MM-DD)
 */

export async function fetchVacationsInRange({ schoolId, startDateISO, endDateISO }) {
  if (!schoolId || !startDateISO || !endDateISO) return [];

  // Overlap query:
  // vacation.start_date <= rangeEnd AND vacation.end_date >= rangeStart
  const { data, error } = await supabase
    .from('school_vacations')
    .select('id, school_id, title, start_date, end_date, created_at, updated_at')
    .eq('school_id', schoolId)
    .lte('start_date', endDateISO)
    .gte('end_date', startDateISO)
    .order('start_date', { ascending: true });

  if (error) throw error;
  return data || [];
}

export async function createVacation({ schoolId, title, startDateISO, endDateISO }) {
  if (!schoolId) throw new Error('Missing schoolId');
  if (!startDateISO) throw new Error('Start date is required');
  if (!endDateISO) throw new Error('End date is required');
  if (String(endDateISO) < String(startDateISO)) throw new Error('End date must be on or after start date');

  const { data, error } = await supabase
    .from('school_vacations')
    .insert({
      school_id: schoolId,
      title: title?.trim() || null,
      start_date: startDateISO,
      end_date: endDateISO,
    })
    .select('id, school_id, title, start_date, end_date, created_at, updated_at')
    .single();

  if (error) throw error;
  return data;
}

export async function updateVacation({ vacationId, updates }) {
  if (!vacationId) throw new Error('Missing vacationId');
  if (!updates || typeof updates !== 'object') throw new Error('Missing updates');

  const nextStart = updates.start_date;
  const nextEnd = updates.end_date;
  if (nextStart && nextEnd && String(nextEnd) < String(nextStart)) {
    throw new Error('End date must be on or after start date');
  }

  const { data, error } = await supabase
    .from('school_vacations')
    .update(updates)
    .eq('id', vacationId)
    .select('id, school_id, title, start_date, end_date, created_at, updated_at')
    .single();

  if (error) throw error;
  return data;
}

export async function deleteVacation({ vacationId }) {
  if (!vacationId) throw new Error('Missing vacationId');
  const { error } = await supabase.from('school_vacations').delete().eq('id', vacationId);
  if (error) throw error;
  return true;
}


